import React from "react";

import styles from "./MessageContainer.module.scss";

export const MessageContainer = ({ img, message }) => (
  <section className={styles.messageContainer}>
    <img src={img} alt="Message Image" />
    <h4 className={styles.messageText}>{message}</h4>
  </section >
);